import React, { createContext, useContext, useReducer } from 'react'

interface State {
  loading: boolean
  locations: any[]
  totalPage: number
  currentPage: number
  search: string
}

interface Action {
  type: string
  payload?: any
}

const initState: State = {
  loading: false,
  locations: [],
  totalPage: 1,
  currentPage: 1,
  search: '',
}

const DeviceLocationContext = createContext<any>(null)

function reducer(state: State, { type, payload }: Action) {
  switch (type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload,
      }
    case 'SET_LOCATIONS':
      return {
        ...state,
        loading: false,
        locations: payload.data,
        totalPage: payload.meta.last_page,
      }
    case 'SET_CURRENT_PAGE':
      return {
        ...state,
        currentPage: payload,
      }
    case 'SET_SEARCH':
      return {
        ...state,
        search: payload,
        currentPage: 1,
      }
    default:
      return state
  }
}

const DeviceContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState)

  return (
    <DeviceLocationContext.Provider value={{ ...state, dispatch }}>
      {children}
    </DeviceLocationContext.Provider>
  )
}

const useLocationContext = () => {
  return useContext(DeviceLocationContext)
}

export { DeviceContextProvider as default, useLocationContext }
